var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-content"},[_c('h1',{staticClass:"mt-0"},[_vm._v("Terms of Use")])])
}]

export { render, staticRenderFns }